import { config } from 'process';
import { transChoice } from 'laravel-vue-i18n';
import { useConfirm } from 'primevue/useconfirm';
export default class ConfirmationService {
    confirm;
    constructor() {
        this.confirm = useConfirm();
    }
    confirmDelete(accept = () => { }, reject = () => { }) {
        this.confirm.require({
            message: "Confermi l'eliminazione del record selezionato?",
            header: 'Conferma Eliminazione',
            icon: 'pi pi-info-circle',
            accept,
            reject,
        });
    }
    confirmDeleteMultiple(count, accept = () => { }, reject = () => { }) {
        const message = transChoice('messages.deleteConfirm', count, {
            count: count.toString(),
        });
        this.confirm.require({
            message,
            header: 'Conferma Eliminazione',
            icon: 'pi pi-info-circle',
            acceptIcon: 'pi pi-check',
            rejectIcon: 'pi pi-times',
            accept,
            reject,
        });
    }
}
